<template>
  <v-container>
    <p class="step-title">{{ $t('identifierStep.title') }}</p>
    <HfrCard>
      <v-form ref="identifierForm" v-model="isFormValid">
        <v-text-field
          v-model="form.insuranceCardNumber"
          :label="$t('identifierStep.cardNo')"
          filled
          class="required"
          readonly
          :rules="[rules.required, rules.cardNumber]">
        </v-text-field>
        <v-text-field
          v-model="form.insuranceName"
          :label="$t('identifierStep.insuranceName')"
          filled
          readonly
          class="required"
          :rules="[rules.required]">
        </v-text-field>
        <p class="field-warning mb-0">{{ $t('identifierStep.verifyName') }}</p>
        <v-text-field
          v-model="form.lastName"
          :label="$t('identifierStep.lastName')"
          filled
          class="required"
          :rules="[rules.required]">
        </v-text-field>
        <p class="field-warning mb-0">{{
          $t('identifierStep.verifyFirstName')
        }}</p>
        <v-text-field
          v-model="form.firstName"
          :label="$t('identifierStep.firstName')"
          filled
          class="required"
          :rules="[rules.required]">
        </v-text-field>
        <v-text-field
          v-show="false"
          v-model="form.avs_no"
          :label="$t('identifierStep.avsNo')"
          filled>
        </v-text-field>
        <v-menu
          ref="birthdateMenu"
          v-model="birthdateMenu"
          :close-on-content-click="false"
          :return-value.sync="formattedBirthdate"
          transition="scale-transition"
          offset-y
          min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="formattedBirthdate"
              :label="$t('insuranceCardStep.birthDate')"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              class="required"
              v-on="on"
              filled
              :rules="[rules.required]" />
          </template>
          <v-date-picker
            v-model="form.birthdate"
            min="1880-01-01"
            locale="fr-CH"
            :first-day-of-week="1"
            :active-picker.sync="activeBirthdatePicker"
            @blur="date = doParseDate(dateFormatted)"
            @change="saveBirthdate" />
        </v-menu>
      </v-form>
    </HfrCard>
  </v-container>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import HfrCard from '../ui/HfrCard.vue';
import { formatDate, parseDate } from '@/helpers/dates';
import { cardNoRule, requiredRule } from '@/helpers/validationRules';

export default {
  name: 'IdentifierStep',
  data() {
    return {
      isFormValid: null,
      form: {
        insuranceCardNumber:
          process.env.VUE_APP_PREFILL_FORMS === 'true'
            ? 12312312312312312311
            : null,
        insuranceName:
          process.env.VUE_APP_PREFILL_FORMS === 'true'
            ? 'Rock Assurance'
            : null,
        firstName: process.env.VUE_APP_PREFILL_FORMS === 'true' ? 'Dave' : null,
        lastName: process.env.VUE_APP_PREFILL_FORMS === 'true' ? 'Grohl' : null,
        birthdate:
          process.env.VUE_APP_PREFILL_FORMS === 'true' ? '1988-01-01' : null,
        avs_no:
          process.env.VUE_APP_PREFILL_FORMS === 'true' ? '7561318814367' : null
      },
      rules: {
        required: requiredRule,
        cardNumber: cardNoRule
      },
      activeBirthdatePicker: null,
      birthdateMenu: false,
      stepNumber: 3
    };
  },
  watch: {
    userInfo: {
      handler() {
        this.fillFormDataWithUserInfo();
      }
    },
    insuranceCardInfo: {
      handler(insuranceCardInfo) {
        if (insuranceCardInfo) {
          this.fillFormData();
        }
      }
    },
    isFormValid(isValid) {
      this.setFormValidity(isValid);
    },
    navigateToNextStep: {
      handler(navigateToNextStep) {
        if (this.currentStep === this.stepNumber && navigateToNextStep) {
          this.validateIdentifierForm();
        }
      }
    },
    birthdateMenu(val) {
      val && setTimeout(() => (this.activeBirthdatePicker = 'YEAR'));
    }
  },
  computed: {
    ...mapState('navigation', ['navigateToNextStep', 'currentStep']),
    ...mapState('insuranceCard', ['insuranceCardInfo']),
    ...mapState('preAdmission', ['userInfo']),
    formattedBirthdate: {
      get() {
        return formatDate(this.form.birthdate);
      },
      set() {}
    }
  },
  methods: {
    ...mapActions('navigation', [
      'setFormValidity',
      'doNextStep',
      'toggleNavigateToNextStep'
    ]),
    ...mapActions('preAdmission', ['storeIdentifierStep']),
    fillFormData() {
      const infos = this.insuranceCardInfo.data;
      if (infos != null) {
        this.form.insuranceCardNumber = infos.cardNo.vekaNo;
        const baseInformation = infos['CH-Baseinformation'];
        this.form.insuranceName =
          baseInformation.administrativeData.nameOfTheInstitution;
        this.form.firstName =
          baseInformation.identificationData.name.firstname[0];
        this.form.lastName =
          baseInformation.identificationData.name.officialName;
        this.form.birthdate =
          baseInformation.identificationData.dateOfBirth.yearMonthDay;
        this.form.avs_no =
          baseInformation.identificationData.cardholderIdentifier;
      }
    },
    fillFormDataWithUserInfo() {
      if (this.userInfo && this.userInfo.patient) {
        this.form.firstName = this.userInfo.patient.last_name;
        this.form.lastName = this.userInfo.patient.first_name;
        this.form.birthdate = this.userInfo.patient.birthdate;
        this.form.avs_no = this.userInfo.patient.avs_no;
      }
      this.$refs.identifierForm.resetValidation();
    },
    saveBirthdate(date) {
      this.$refs.birthdateMenu.save(date);
    },
    doParseDate(date) {
      return parseDate(date);
    },
    validateIdentifierForm() {
      if (this.$refs.identifierForm.validate()) {
        this.storeIdentifierStep(this.form);
        this.doNextStep();
      }
      this.toggleNavigateToNextStep();
    }
  },
  components: { HfrCard }
};
</script>
